import classNames from 'classnames';

type CardEventProps = (
  | {
      type: 'created';
      isDefault: boolean;
    }
  | {
      type: 'updated';
      isDefault: {
        old: boolean;
        new: boolean;
      };
    }
  | {
      type: 'deleted';
      isDefault: undefined;
    }
) & { last4: string };

const PRIMARY = 'Primary Card';
const NOT_PRIMARY = 'Not Primary Card';

export function CardEvent(props: CardEventProps) {
  const { type, last4, isDefault } = props;
  let description;

  if (type === 'created') {
    description = isDefault ? PRIMARY : NOT_PRIMARY;
  }
  if (type === 'updated') {
    description = isDefault.new ? PRIMARY : NOT_PRIMARY;
  }
  if (type === 'deleted') {
    description = null;
  }

  return (
    <div className="flex text-xs">
      <div
        className={classNames('border-slate-100 pr-2', {
          'border-r': type !== 'deleted',
        })}
      >
        ••••&nbsp;{last4}
      </div>
      <div className="pl-2">{description}</div>
    </div>
  );
}
